import { MyTourPreview } from 'entities/tour/ui/my-tour-card'

import { TourDocumentPreview } from 'shared/api/tours/main-page'

export const mapTourDocumentsToPreviews = (data: unknown): MyTourPreview[] => {
  const documents =
    typeof data === 'object' && data !== null
      ? (data as { document?: unknown }).document
      : undefined

  if (!Array.isArray(documents)) {
    throw new Error('Invalid tour documents response')
  }

  return documents.map((document) => {
    const item = document as TourDocumentPreview

    return {
      id: item.id,
      status: item.status,
      hotel: item.hotel || item.title,
      startDate: item.start_date,
      endDate: item.end_date,
      nights: item.nights,
      tourists: item.tourists_count,
      image: item.cover || '',
    }
  })
}
